import { t } from "ttag";

import { useMessenger } from "@/app/hooks/use-messenger";
import type { ModalProps } from "@/shared/models/legacy-types";
import { Button, Dialog, ShieldWarningIcon } from "@/shared/ui";

export const BestFitModal = ({ show, onClose }: ModalProps) => {
  const {
    actions: { showMessenger },
  } = useMessenger();

  const handleContactSupport = () => {
    onClose();
    showMessenger();
  };

  return (
    <Dialog.Root open={show} onOpenChange={onClose}>
      <Dialog.Content>
        <Dialog.Header icon={ShieldWarningIcon}>
          <Dialog.Title>{t`It appears that LevelsRx may not be the best fit for you at the moment`}</Dialog.Title>
          <Dialog.Description>
            {t`While LevelsRx may not align with your current needs, it's just the beginning of discovering what works best for you. Get in touch with us so we can provide some guidance.`}
          </Dialog.Description>
        </Dialog.Header>

        <Dialog.Footer>
          <Button size="lg" onClick={handleContactSupport}>
            {t`Contact Customer support`}
          </Button>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog.Root>
  );
};
